import { Component, h, State, Prop } from '@stencil/core';
import dayjs from 'dayjs';
import { DateHelper } from '../../date.helper';
import 'dayjs/locale/it';

@Component({
  tag: 'pnk-datepicker-header',
  styleUrl: 'pnk-datepicker-header.css',
})
export class PnkDatePickerHeader {
  @Prop() language: string = 'it';

  @Prop() currentDay: Date = new Date();

  @Prop() yearFrom?: number;

  @Prop() yearTo?: number;

  @Prop() dateChange!: (date: Date) => void;

  @State() editModeFlags: boolean[] = [false, false, false];

  componentWillLoad() {
    this.toggleEditModes(-1);
  }

  // component used to show the header of the datepicker where you can select the month and the year with two other components
  // month selector and part selector
  render() {
    return [
      <div class="pnk-h-10 pnk-flex pnk-text-base pnk-text-black pnk-p-[5px] pnk-justify-between">
        <div
          class=" pnk-justify-center pnk-h-[30px] pnk-w-[75px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white pnk-rounded pnk-items-center"
          onClick={() => this.toggleEditModes(1)}
        >
          <div class="pnk-flex">
            <span>{dayjs(this.currentDay).locale(this.language).format('MMMM')}</span>
          </div>
        </div>

        <div
          class="pnk-justify-center pnk-h-[30px] pnk-w-[75px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white pnk-rounded pnk-items-center pnk-align-middle"
          onClick={() => this.toggleEditModes(2)}
        >
          <div class="pnk-flex">
            <span>{this.currentDay.getFullYear()}</span>
          </div>
        </div>
      </div>,

      <div>
        {
          <pnk-date-month-selector
            mode="m"
            dateChange={date => this.handleDateChange(date)}
            dataSource={DateHelper.getMonthDataSource(this.language)}
            date={this.currentDay}
            show={this.editModeFlags[1]}
          ></pnk-date-month-selector>
        }
        {
          <pnk-date-part-selector
            mode="y"
            dateChange={date => this.handleDateChange(date)}
            dataSource={DateHelper.getYearDataSource(this.yearFrom, this.yearTo)}
            date={this.currentDay}
            show={this.editModeFlags[2]}
          ></pnk-date-part-selector>
        }
      </div>,
    ];
  }

  private handleDateChange(date: Date): void {
    this.toggleEditModes(-1);
    this.dateChange(date);
  }

  private toggleEditModes(index: number) {
    this.editModeFlags = [...Array.from(Array(3).keys()).map(item => (item === index ? !this.editModeFlags[index] : false))];
  }
}
